import React from "react";
import PropTypes from "prop-types";

import StoreMap from "@components/Stores/StoreMap";
import Heading from "@components/Heading";
import StoreSchedule from "@components/Stores/StoreSchedule";

const StoreContainer = ({ store }) => {
  const {
    name,
    address,
    first_name: managerfFirstName,
    last_name: managerLastName,
    phone: phoneNumber,
    schedule,
    special_schedule,
    latitude: geoPositionLatitude,
    longitude: geoPositionLongitude,
  } = store;

  return (
    <div className="mt-6">
      <StoreMap
        latitude={geoPositionLatitude}
        longitude={geoPositionLongitude}
        name={name}
        address={address}
      />

      <div className="mt-8 sm:flex sm:flex-wrap -mx-3">
        <div className="md:w-1/3 px-3">
          <Heading
            title={name}
            classesProp="-tracking-0.48 lg:-tracking-0.5"
            as="h2"
            display="h2"
          />
          {address && (
            <p className="mt-4 mb-8 text-sm md:text-base pr-10 -tracking-0.29 lg:-tracking-0.33">
              {address}
            </p>
          )}
        </div>

        {schedule && schedule.length && (
          <div className="md:w-1/3 px-3">
            <Heading
              title={`Program de lucru`}
              classesProp="-tracking-0.48 lg:-tracking-0.5"
              as="h2"
              display="h2"
            />

            <p className="mt-4 mb-8 text-sm md:text-base pr-10 -tracking-0.29 lg:-tracking-0.33">
              <StoreSchedule
                schedule={schedule}
                special_schedule={special_schedule}
              />
            </p>
          </div>
        )}

        <div className="md:w-1/3 px-3">
          <Heading
            title={`Contact`}
            classesProp="-tracking-0.48 lg:-tracking-0.5"
            as="h2"
            display="h2"
          />

          <p className="mt-4 mb-8 text-sm md:text-base pr-10 -tracking-0.29 lg:-tracking-0.33">
            {managerfFirstName && managerLastName && (
              <p className="m-0 mt-1">
                <span className="font-medium mr-1">{`Telefon`}:</span>
                {` ${phoneNumber}`}
              </p>
            )}

            {phoneNumber && (
              <p className="m-0 mt-1">
                <span className="font-medium mr-1">{`Manager`}:</span>
                {` ${managerfFirstName} ${managerLastName}`}
              </p>
            )}
          </p>
        </div>
      </div>
    </div>
  );
};

StoreContainer.propTypes = {
  store: PropTypes.shape({
    id: PropTypes.number.isRequired,
    name: PropTypes.string.isRequired,
    address: PropTypes.string.isRequired,
    first_name: PropTypes.string,
    last_name: PropTypes.string,
    phoneNumber: PropTypes.string,
    schedule: PropTypes.array,
  }),
};

export default StoreContainer;
